// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__1j6S7","title":"ClientInsurance_title__1smze","itemText":"ClientInsurance_itemText__1OTFo"};